<template>
  <div class="main container-fluid no-access-page">
    <section class="no-access-card">
      <div class="no-access-icon"><i class="bi bi-shield-lock"></i></div>
      <h4 class="mb-2">Нет доступа</h4>
      <p class="text-muted mb-3">Для перехода в админ-раздел требуется роль <strong>ROLE_ADMIN</strong>.</p>
      <router-link to="/dashboard" class="btn btn-primary btn-sm">Вернуться в дашборд</router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AdminNoAccessPage',
}
</script>

<style scoped>
.no-access-page {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background:
    radial-gradient(circle at 12% 20%, rgba(13, 110, 253, 0.1), transparent 40%),
    radial-gradient(circle at 85% 80%, rgba(25, 135, 84, 0.08), transparent 45%),
    #f7f9fd;
}

.no-access-card {
  width: min(560px, 100%);
  border-radius: 16px;
  border: 1px solid #dce7fa;
  background: #fff;
  text-align: center;
  padding: 18px;
  box-shadow: 0 14px 36px rgba(17, 24, 39, 0.12);
}

.no-access-icon {
  margin: 0 auto 10px;
  width: 58px;
  height: 58px;
  border-radius: 14px;
  border: 1px solid #d5e3f8;
  color: #2f5f9d;
  background: #eef5ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
</style>
